import { IPlayerGame } from '@grassrootly/api/entities';
import { IGame } from "@grassrootly/api/entities/IGame";
import { provider } from "@grassrootly/api/providers";

export interface GetPlayersNextGamesPayload {
  date_from: string;
  pid: number;
}

export const GetPlayerNextGames = async (params: GetPlayersNextGamesPayload): Promise<IPlayerGame[]> =>
  provider.Request("/next-games", params);
